































import Vue from 'vue';

import { components, methods, props } from './common';

export default Vue.extend({
  name: 'SenderDetails',
  components,
  props,
  methods,
});
